export const SupplierCard = {
  flow: 'y',
  gap: 'Z',
  padding: 'B',
  round: 'Z',
  background: 'inkMid',
  border: '1px solid inkBorder',

  HeaderRow: {
    flow: 'x',
    align: 'center flex-start',
    justifyContent: 'space-between',
    SupplierName: { text: (el, s) => s.name || '', fontSize: 'Z', fontWeight: '700', color: 'inkText' },
    AvailabilityBadge: {
      tag: 'span',
      text: (el, s) => s.deliveryAvailable ? '{{ available | polyglot }}' : '{{ unavailable | polyglot }}',
      fontSize: 'Y',
      fontWeight: '600',
      padding: 'X Z',
      round: 'B',
      background: (el, s) => s.deliveryAvailable ? 'green.15' : 'red.15',
      color: (el, s) => s.deliveryAvailable ? 'green' : 'red'
    }
  },

  ContactInfo: {
    flow: 'y',
    gap: 'X',
    ContactName: { text: (el, s) => s.contact || '', fontSize: 'Z', color: 'inkText' },
    Phone: { text: (el, s) => s.phone || '', fontSize: 'Y', color: 'inkMuted' }
  },

  RatingRow: {
    flow: 'x',
    gap: 'Y',
    align: 'center flex-start',
    RatingLabel: { text: '{{ reliability | polyglot }}', fontSize: 'Y', color: 'inkMuted' },
    RatingStars: {
      flow: 'x',
      gap: 'X',
      text: (el, s) => {
        const r = s.rating || 0
        return '\u2605'.repeat(Math.round(r)) + '\u2606'.repeat(5 - Math.round(r))
      },
      fontSize: 'Z',
      color: 'amber'
    }
  },

  Divider: { height: '1px', background: 'inkBorder' },

  DeliveryRow: {
    flow: 'x',
    gap: 'A',
    flexWrap: 'wrap',
    EstDays: {
      flow: 'y',
      gap: 'X',
      Label: { text: '{{ estDelivery | polyglot }}', fontSize: 'Y', color: 'inkMuted' },
      Value: { text: (el, s) => s.estimatedDays ? `${s.estimatedDays} {{ days | polyglot }}` : '—', fontSize: 'Z', fontWeight: '600', color: 'inkText' }
    },
    MinOrder: {
      flow: 'y',
      gap: 'X',
      Label: { text: '{{ minOrder | polyglot }}', fontSize: 'Y', color: 'inkMuted' },
      Value: { text: (el, s) => s.minimumOrder || '—', fontSize: 'Z', fontWeight: '600', color: 'inkText' }
    }
  },

  PlaceOrderBtn: {
    extends: 'Button',
    tag: 'button',
    text: '{{ placeOrder | polyglot }}',
    background: 'teal',
    color: 'ink',
    fontWeight: '600',
    padding: 'Y A',
    round: 'A',
    fontSize: 'Y',
    cursor: 'pointer',
    border: 'none',
    alignSelf: 'flex-start'
  }
}
